import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Renders the backend's email HTML in an isolated frame. `sandbox` without
 * allow-scripts means nothing in it can run (all values are also escaped
 * server-side); allow-same-origin only lets this component read its height.
 */
export default function EmailPreviewFrame({ html }) {
  const ref = useRef(null);
  const [height, setHeight] = useState(320);

  const fit = useCallback(() => {
    const doc = ref.current?.contentDocument;
    if (doc?.documentElement) setHeight(Math.max(200, doc.documentElement.scrollHeight + 8));
  }, []);

  useEffect(() => {
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, [fit]);

  return (
    <iframe ref={ref} title="Email preview" srcDoc={html} sandbox="allow-same-origin" onLoad={fit}
      style={{ height }} className="w-full border-0 bg-white rounded-md" data-testid="ca-preview-frame" />
  );
}
